import classNames from 'classnames';
import { Button, Countdown } from 'hem-ui';
import React from 'react';

import { cn } from '@/utils';

import { Theme } from './hero-types.d';

type Props = {
  hero: Queries.HomepageHeroFragment;
  titleTag?: 'h1' | 'h2' | 'h3';
  theme: string;
};

const HeroLeftContent: React.FC<Props> = ({
  hero,
  titleTag = 'h1',
  theme = Theme.WHITE,
}) => {
  const Title = titleTag;
  // @ts-expect-error hard typing
  const linkSlug = hero.link?.slug || hero.link?.entry?.slug;
  const secondaryLinkSlug =
    // @ts-expect-error hard typing
    hero.secondaryLink?.slug || hero.secondaryLink?.entry?.slug;

  return (
    <div className="grid grid-cols-12 gap-2 md:gap-4">
      <div className="col-span-full @3xl/hero:col-start-2 @3xl/hero:col-end-12">
        {!!hero.title && (
          <Title
            className={classNames('text-balance', {
              'hero-headline-h1': titleTag === 'h1',
              'hero-headline-h2': titleTag !== 'h1',
            })}
          >
            {hero.title}
          </Title>
        )}

        {!!hero.description && (
          <p className="mt-4 max-w-prose text-balance text-lg text-[color:--hero-text-color]">
            {hero.description}
          </p>
        )}

        {!!hero.countdownTimer && (
          <Countdown countdownTimer={new Date(hero.countdownTimer)} />
        )}

        <div className="mt-8 flex gap-4 @3xl/hero:mt-16">
          {!!linkSlug && !!hero.linkLabel && (
            <Button
              to={linkSlug}
              className="!bg-[color:--hero-button-color] !text-[color:--hero-button-text-color] hover:!bg-[color:--hero-button-hover-color] hover:!text-[color:--hero-button-hover-text-color]"
            >
              {hero.linkLabel}
            </Button>
          )}

          {!!secondaryLinkSlug && !!hero.secondaryLinkLabel && (
            <Button
              to={secondaryLinkSlug}
              className={cn({
                '!bg-black !text-white hover:!bg-black-900':
                  theme === Theme.WHITE,
                '!bg-white !text-black hover:!bg-black-100':
                  theme === Theme.BLACK,
                '!bg-white/70 !text-blue hover:!bg-white/80':
                  theme === Theme.BLUE,
                '!bg-green-matte !text-green-gloss hover:!bg-green-matte-300':
                  theme === Theme.GREEN,
                '!bg-hem-x !text-white hover:!bg-hem-x': theme === Theme.HEM_X,
                '!bg-white !text-red-gloss hover:!bg-red-matte':
                  theme === Theme.RED,
                '!bg-yellow-matte !text-black hover:!bg-yellow-matte-100':
                  theme === Theme.YELLOW,
              })}
            >
              {hero.secondaryLinkLabel}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeroLeftContent;
